import { createElement } from '../../../core/dom/helpers.js';
import { attachCharCounter } from '../../../core/dom/char-counter.js';

/** @type {import('../../../contracts/forms.js').FieldDriver} */
export const textDriver = {
  type: 'text',
  mount(container, ctx) {
    const { def, onChange } = ctx;
    const inputType = /** @type {import('../../../contracts/forms.js').TextFieldDef} */ (def).inputType ?? 'text';

    const input = /** @type {HTMLInputElement} */ (createElement('input', {
      type: inputType,
      id: `field-${def.key}`,
      name: def.key,
      class: 'form-field-input',
    }));
    if (def.placeholder) input.setAttribute('placeholder', def.placeholder);
    if (def.required) { input.setAttribute('required', 'required'); input.setAttribute('aria-required', 'true'); }
    if (def.disabled) input.setAttribute('disabled', 'disabled');
    input.addEventListener('input', () => onChange(input.value));

    container.appendChild(input);

    if (ctx.value !== undefined) {
      input.value = ctx.value == null ? '' : String(ctx.value);
    }

    const textDef = /** @type {import('../../../contracts/forms.js').TextFieldDef} */ (def);
    const counter = textDef.maxLength ? attachCharCounter(input, textDef.maxLength) : null;

    return {
      setValue(value) {
        input.value = value == null ? '' : String(value);
      },
      getValue() {
        return input.value;
      },
      setErrors() {
        // errors rendered by host (form-field wrapper)
      },
      destroy() {
        counter?.destroy();
        input.remove();
      },
      setDisabled(disabled) {
        input.disabled = disabled;
      },
      clearValue() {
        input.value = '';
      },
      setAriaInvalid(invalid) {
        input.setAttribute('aria-invalid', invalid ? 'true' : 'false');
      },
    };
  },
};
